import thermometerGreenIcon from './assets/ico-temp-green.svg';
import thermometerYellowIcon from './assets/ico-temp-yellow.svg';
import thermometerRedIcon from './assets/ico-temp-red.svg';

const RiskIndicator = ({ riskLevel, productType }) => { 
    let thermometerIcon; 
    let className; 
    let levelIndicator; 
    let isEPSVSProductType = productType && productType.toLowerCase() === 'epvs';
   
    if (riskLevel > 0 && riskLevel <= 2) { 
        thermometerIcon = thermometerGreenIcon; 
        className = 'tempGreen'; 
        levelIndicator = isEPSVSProductType ? 'Bajo' : riskLevel;
     } else if (riskLevel >= 3 && riskLevel <= 4 ) { 
        thermometerIcon = thermometerYellowIcon; 
        className = 'tempYellow'; 
        levelIndicator = isEPSVSProductType ? 'Medio' : riskLevel; 
    } else if (riskLevel >= 5 && riskLevel <= 7) { 
        thermometerIcon = thermometerRedIcon; 
        className = 'tempRed'; 
        levelIndicator = isEPSVSProductType ? 'Alto' : riskLevel; 
    }
    return ( 
        <>
        {levelIndicator && <img src={thermometerIcon} alt='thermometer' />}
        <label className={isEPSVSProductType ?  className + ' riskLevel' : className}>
            {levelIndicator}
        </label>
        </>
        )
     }

export default RiskIndicator;


